import React, { FC, ReactNode } from "react";

// import SEO from "src/components/SEO";

import {
    StyledContainer,
    StyledOuter,
    StyledInner,
} from "./PageWrapper.styled";

type Props = {
    children: ReactNode;
    title?: string;
    header?: ReactNode;
    bgColor?: string;
};

const PageWrapper: FC<Props> = ({ children, title = "", header }: Props) => (
    <StyledContainer>
        {/* <SEO
            //  TODO: add default SEO props here
            title={title}
        /> */}

        {header}

        <StyledOuter>
            <StyledInner>
                {/* <StyledWarningBubble>
                    Comment the wording below in and out if needed, only in exceptional cases 
                    🍎 Continue with Apple may not work as expected. We're
                    working on a fix 🔨
                </StyledWarningBubble> */}
                {children}
            </StyledInner>
        </StyledOuter>
    </StyledContainer>
);

export default PageWrapper;
